import { HTMLAttributes, ReactNode } from 'react'
import { Divider, MenuItem, Typography } from '@mui/material'
import { GpsDeviceIdOption } from '../../types'

const mainTextSx = { marginRight: 2 }
const secondaryTextSx = { textAlign: 'right', marginLeft: 'auto' }

export function renderOption(
  liProps: HTMLAttributes<HTMLLIElement>,
  option: GpsDeviceIdOption,
): ReactNode {
  switch (option.preset) {
    case 'divider':
      return <Divider key={option.value} />

    case 'secondaryText':
      return (
        <MenuItem {...liProps} key={option.value} value={option.value} disabled={option.disabled}>
          <Typography noWrap sx={mainTextSx}>
            {option.label}
          </Typography>

          <Typography sx={secondaryTextSx} noWrap>
            {option.secondaryText}
          </Typography>
        </MenuItem>
      )

    default:
      return (
        <MenuItem {...liProps} key={option.value} value={option.value} disabled={option.disabled}>
          {option.label}
        </MenuItem>
      )
  }
}
